/*
  Pre-order pages: countdown + offer expiry. Loaded by every sections/preorder-*.liquid, so it guards against running twice.
  Reads the deadline from data-ps-end on the script tag (theme setting "Offer ends").
  At the deadline (or with ?psh30_expired=1) it hides the countdown and every .psh30 [data-ps-offer] element.
*/
(function () {
  if (window.psPreorderInit) return;
  window.psPreorderInit = true;

  var source = document.querySelector('script[data-ps-end]');
  if (!source) return;

  var end = new Date(source.getAttribute('data-ps-end')).getTime();
  var forceExpired = /[?&]psh30_expired=1\b/.test(location.search);
  var timer = document.getElementById('ps-h30-timer');
  var interval;

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function expire() {
    clearInterval(interval);
    document.querySelectorAll('.psh30 [data-ps-offer]').forEach(function (el) {
      el.hidden = true;
    });
  }

  function tick() {
    var left = forceExpired ? 0 : Math.max(0, end - Date.now());
    if (!left) return expire();
    if (!timer) return;

    timer.classList.add('is-live');
    timer.querySelector('[data-u="d"]').textContent = Math.floor(left / 864e5);
    timer.querySelector('[data-u="h"]').textContent = pad(Math.floor(left / 36e5) % 24);
    timer.querySelector('[data-u="m"]').textContent = pad(Math.floor(left / 6e4) % 60);
    timer.querySelector('[data-u="s"]').textContent = pad(Math.floor(left / 1e3) % 60);
  }

  // An invalid end date would otherwise expire the offer straight away
  if (isNaN(end) && !forceExpired) return;

  tick();
  interval = setInterval(tick, 1000);
})();
